import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import { savedEmailTemplateSchema } from "@redotech/redo-model/saved-email-template";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSavedEmailTemplateById = {
  name: "getSavedEmailTemplateById" as const,
  input: z.object({ templateId: zExt.objectId() }),
  output: savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>,
};
